import { render } from "./BomValidationSimilarSolutions.vue?vue&type=template&id=3b606407&scoped=true"
import script from "./BomValidationSimilarSolutions.vue?vue&type=script&lang=js"
export * from "./BomValidationSimilarSolutions.vue?vue&type=script&lang=js"

import "./BomValidationSimilarSolutions.vue?vue&type=style&index=0&id=3b606407&lang=scss&scoped=true"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b606407"]])

export default __exports__